<div class="ui-control ui-inline-control" [formGroup]="formGroup">
  <span class="input-label">{{inputData.label}}</span>
  <input class="input-control" [formControlName]="inputData.colName" type="text" pInputText />
</div>


<!-- Visible on group -->
<!-- Disabled on input -->
<!-- Display name on label -->
<!-- Is required -->